// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.impact {
  background: var(--white);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  margin-bottom: 80px;
}

.stat-card {
  position: relative;
  padding: 44px 32px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  border-radius: 20px;
  overflow: hidden;
  color: var(--white);
  transition: var(--transition);
  box-shadow: var(--shadow-md);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 50px rgba(0, 102, 204, 0.35);
}

.stat-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat-card .stat-number {
  font-size: 48px;
  font-weight: 800;
  line-height: 1;
  color: var(--white);
}

.stat-label {
  font-size: 18px;
  font-weight: 600;
  color: var(--white);
  margin: 0;
}

.stat-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

.stat-decoration {
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  z-index: 1;
}

.impact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 64px;
}

.impact-card {
  background: var(--white);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  border: 1px solid var(--border-color);
}

.impact-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
  border-color: transparent;
}

.impact-image {
  position: relative;
  overflow: hidden;
  height: 250px;
}

.impact-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition);
}

.impact-card:hover .impact-image img {
  transform: scale(1.1);
}

.impact-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 30px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
}

.impact-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--white);
  margin: 0;
}

.impact-content {
  padding: 24px;
}

.impact-description {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-light);
  margin: 0;
}

.impact-cta {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  padding: 60px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  color: var(--white);
}

.cta-content {
  flex: 1 1;
}

.cta-title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  color: var(--white);
}

.cta-description {
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
}

.cta-actions {
  display: flex;
  gap: 16px;
  flex-shrink: 0;
}

@media (max-width: 968px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .impact-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .impact-cta {
    flex-direction: column;
    text-align: center;
    padding: 40px;
  }

  .cta-title {
    font-size: 28px;
  }

  .cta-actions {
    width: 100%;
    flex-direction: column;
  }

  .cta-actions .btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 30px 24px;
  }

  .stat-card .stat-number {
    font-size: 36px;
  }

  .impact-cta {
    padding: 30px 24px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Impact.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yFAAyF;EACzF,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,yFAAyF;EACzF,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".impact {\n  background: var(--white);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 32px;\n  margin-bottom: 80px;\n}\n\n.stat-card {\n  position: relative;\n  padding: 44px 32px;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  border-radius: 20px;\n  overflow: hidden;\n  color: var(--white);\n  transition: var(--transition);\n  box-shadow: var(--shadow-md);\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 50px rgba(0, 102, 204, 0.35);\n}\n\n.stat-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.stat-card .stat-number {\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1;\n  color: var(--white);\n}\n\n.stat-label {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--white);\n  margin: 0;\n}\n\n.stat-description {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.6;\n}\n\n.stat-decoration {\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  z-index: 1;\n}\n\n.impact-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  margin-bottom: 64px;\n}\n\n.impact-card {\n  background: var(--white);\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  transition: var(--transition);\n  border: 1px solid var(--border-color);\n}\n\n.impact-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-xl);\n  border-color: transparent;\n}\n\n.impact-image {\n  position: relative;\n  overflow: hidden;\n  height: 250px;\n}\n\n.impact-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: var(--transition);\n}\n\n.impact-card:hover .impact-image img {\n  transform: scale(1.1);\n}\n\n.impact-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 30px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);\n}\n\n.impact-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--white);\n  margin: 0;\n}\n\n.impact-content {\n  padding: 24px;\n}\n\n.impact-description {\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--text-light);\n  margin: 0;\n}\n\n.impact-cta {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  padding: 60px;\n  border-radius: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 40px;\n  color: var(--white);\n}\n\n.cta-content {\n  flex: 1;\n}\n\n.cta-title {\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 16px;\n  color: var(--white);\n}\n\n.cta-description {\n  font-size: 16px;\n  line-height: 1.8;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 600px;\n}\n\n.cta-actions {\n  display: flex;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n@media (max-width: 968px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n\n  .impact-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .impact-cta {\n    flex-direction: column;\n    text-align: center;\n    padding: 40px;\n  }\n\n  .cta-title {\n    font-size: 28px;\n  }\n\n  .cta-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .cta-actions .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 640px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card {\n    padding: 30px 24px;\n  }\n\n  .stat-card .stat-number {\n    font-size: 36px;\n  }\n\n  .impact-cta {\n    padding: 30px 24px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
